import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants';

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case actions.CLEAR_NEW_USER:
            {
                return getInitialState();
            }
        case actions.SAVE_NEW_USER + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return Map();
};